import { create } from "zustand";
import MetaDataService from "../services/MetaDataService";

const useMetadataStore = create((set, get) => ({
  dataState: "LOADING",
  priceData: [],
  premiumJobData: null,
  fetchMetadata: async () => {
    if (get().dataState === "FETCHED") {
      set({});
      return;
    }
    set({ dataState: "LOADING", priceData: [] });
    try {
      const data = await MetaDataService.getCreditPrice();
      set({ priceData: data });
      set({ premiumJobData: data.find(data => data.id === 1) });
      set({ dataState: "FETCHED" });
    } catch (error) {
      set({ dataState: "ERROR" });
    }
  }
}));

export default useMetadataStore;
